






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class TabGeneral extends Vue {
  @Prop({ required: true, default: {} }) data!: any;

  cols = [
    { field: 'Nombre Baja Cobranza', id: 'nombre_baja_cobranza' },
    { field: 'Fecha Creaión', id: 'fecha_creacion_format' },
    { field: 'Cliente', id: 'cliente' },
    { field: 'Cantidad EPC', id: 'cantidad_epc' },
    { field: 'Descripción', id: 'descripcion' },
    { field: 'Observaciones', id: 'observaciones' },
    { field: 'Estado Conecta', id: 'estado_conecta' },
    { field: 'Estado CRM', id: 'estado_crm' },
    { field: 'Razón Estado', id: 'razon_estado' },
    { field: 'Nombre Tramo Baja Temporal', id: 'nombre_tramo_baja_temporal' },
    {
      field: 'Nombre Tramo Baja Definitiva',
      id: 'nombre_tramo_baja_definitiva',
    },
    { field: 'Fecha Recuperación Cliente', id: 'fecha_recuperacion_cliente' },
    {
      field: 'Fecha Ingreso Baja Definitiva',
      id: 'fecha_ingreso_baja_definitiva',
    },
    {
      field: 'Fecha Ingreso Baja Temporal',
      id: 'fecha_ingreso_baja_temporal',
    },
    { field: 'Glosa CRM', id: 'glosa_api_crm' },
  ];

  mounted() {
    Object.entries(this.data).forEach(
      ([key, val]) => (this.data[key] = val || ' ')
    );
  }
}
